export const notNull = <T>(item: T | undefined): item is T => item != null
